import type { StateCreator } from 'zustand';

import type { RemoveFunctions } from '../../utils/types';
import type { StateSlices } from '..';

export type UiSlice = {
  isNavigationCollapsed: boolean;
  resetUiSlice: () => void;
  setNavigationCollapsed(isCollapsed: boolean): void;
};

const initialState: RemoveFunctions<UiSlice> = {
  isNavigationCollapsed: false,
};

export const createUiSlice: StateCreator<StateSlices, [], [], UiSlice> = (
  set
) => ({
  ...initialState,
  resetUiSlice() {
    set({ ...initialState });
  },
  setNavigationCollapsed(isCollapsed) {
    set({ isNavigationCollapsed: isCollapsed });
  },
});
